import { useVideosContext } from '../../../context/videos-context'
import { Button } from '../../../components/button'
import { VideoItem } from '../video-item'
import * as Styled from './styled'

export const VideoList = () => {
  const { state, dispatch } = useVideosContext()

  const handleAddVideo = () => {
    dispatch({ type: 'ADD_VIDEO' })
  }

  const canRemove = state.videos.length > 1

  return (
    <Styled.VideoListContainer>
      {state.videos.map((video, index) => (
        <VideoItem
          key={video.id}
          videoId={video.id}
          index={index}
          canRemove={canRemove}
        />
      ))}
      <Styled.AddVideoButtonWrapper>
        <Button onClick={handleAddVideo} variant="secondary">
          ➕ Add Video
        </Button>
      </Styled.AddVideoButtonWrapper>
    </Styled.VideoListContainer>
  )
}
